import server from 'utils/request';

/**
 * 登陆接口
 * @param data
 */
export function login(data) {
  return server({
    url: '/sys/login',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}

/**
 * 登出接口
 * @param data
 */
export function logout() {
  return server({
    url: '/sys/logout',
    method: 'get'
  })
}

/**
 * 修改密码
 * @param data
 */
export function changePwd(data) {
  return server({
    url: '/sys/updatePwd',
    method: 'post',
    data,
    transformRequest: [function (data) {
      var bodyFormData = new FormData()
      for (let it in data) {
        if (typeof data[it] == 'string') {
          bodyFormData.append(it, data[it].trim())
        } else {
          bodyFormData.append(it, data[it])
        }
      }
      return bodyFormData
    }]
  })
}



// WEBPACK FOOTER //
// ./src/api/login/login.js